module.exports = __webpack_public_path__ + "img/shareLogo.png";